import React, { ReactElement } from 'react';
import { CallFieldMappingResult, CallFieldMappingItemResult } from '../store/selectors/createJobSelectors';
import './MappingResultPreview.scss';

export default function MappingResultPreview(props: Props) {
	const result = props.mappingResult;
	
	return (
		<span className="text-italic">
			{result.type === 'single' && renderValue(result.value, false)}
			{result.type === 'multiple' &&
				<React.Fragment>
					{result.values.map((v, i) => renderValue(v, result.values.length > 1, i, i !== 0))}
				</React.Fragment>
			}
		</span>
	);

	function renderValue(value: CallFieldMappingItemResult, showDisplayName: boolean, key?: number, addSeparatorBefore?: boolean): ReactElement {
		return (
			<React.Fragment key={key}>
				{addSeparatorBefore && props.separator === 'line' && <br />}
				{addSeparatorBefore && props.separator === 'bar' && <span className="mapping-result-preview__item-separator">|</span>}
				{(showDisplayName && value.type !== 'none' && !!value.displayName) && <span className="text-bold">{value.displayName}: </span>}
				{value.type === 'value' && <span>{value.displayValue ?? value.value}</span>}
				{value.type === 'invalid' && <span className="text-red">Invalid</span>}
			</React.Fragment>
		);
	}
}

interface Props {
    mappingResult: CallFieldMappingResult;
    separator: 'line' | 'bar';
}
